module.exports = {
  APP_ID:
    process.env.REACT_APP_APP_ID ||
    "U2fZ7KvIHVvH4snHbkj02uKBpISSWF8C1oePV7iraoy69JrMBvPi",
  API_URL: process.env.REACT_APP_API_URL || "https://api.vie-go.co",
  REST_KEY:
    process.env.REACT_APP_REST_KEY ||
    "UrEeTwu2B5izB28HmtcOm7JpLmDSbSpxILDJ7NdXlA9InpenPj",
};
